import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";

const prefersReducedMotion = () =>
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default function PageLoader({
  isLoading,
  className = "",
  fadeDuration = 0.6,
}) {
  const loaderRef = useRef(null);

  useEffect(() => {
    const el = loaderRef.current;
    if (!el) return;

    const reducedMotion = prefersReducedMotion();

    // Stop an in-progress fade-out; otherwise it keeps running after a new load
    // starts (e.g. quick genre switches) and hides the loader mid-load.
    gsap.killTweensOf(el);

    if (isLoading) {
      gsap.set(el, {
        autoAlpha: 1,
        pointerEvents: "all",
        clearProps: "filter,transform",
      });
    } else {
      gsap.to(el, {
        autoAlpha: 0,
        duration: reducedMotion ? 0 : fadeDuration,
        ease: "power2.out",
        pointerEvents: "none",
      });
    }
  }, [isLoading, fadeDuration]);

  return (
    <div
      ref={loaderRef}
      className={`page-loader ${className}`}
      aria-hidden={!isLoading}
      role="status"
      aria-live="polite"
    >
      <div className="page-loader-inner ">
        <img
          src="/img/ico/spinner.gif"
          alt="Loading"
          className="page-loader-spinner"
        />
      </div>
    </div>
  );
}
